'use strict';

/* globals define, config, $, ajaxify */

var RELATIVE_PATH_TRIMMED = config.relative_path.replace(/^\/|\/$/g, '');

define(RELATIVE_PATH_TRIMMED + '/fill-blanks-game/game-print', [
	config.relative_path + '/plugins/nodebb-plugin-fill-blanks-game/static/vendor/printThis.js',
	'translator',
], function (printThis, translator) {
	var	GamePrint = {};

	GamePrint.init = function () {
		setActions();
	};

	function setActions() {
		$('#print').on('click', function () {
			$('#words').printThis();
		});
	}

	return GamePrint;
});

